import React from 'react'
import { Outlet } from 'react-router-dom'

function PriceCategories() {
  return (
    <div><Outlet /></div>
  )
}

export default PriceCategories